import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import "vant/es/swipe-item/style";
import _SwipeItem from "vant/es/swipe-item";
import "vant/es/swipe/style";
import _Swipe from "vant/es/swipe";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.number.to-fixed.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from "vue";
import BubbleCorner from './BubbleCorner.vue';
Vue.use(_Swipe);
Vue.use(_SwipeItem);
var height = 18;
/**
 * @prop { Object } content
 * mainImg: 图片url
 * mainTitle: 主标题
 * rightTopTitle: 右上角角标文案数组（多则轮播）
 * leftBottomTitle: 左下角icon
*/
export default {
  name: 'circle-bubble',
  props: {
    content: {
      type: Object,
      default: null
    }
  },
  components: {
    BubbleCorner: BubbleCorner
  },
  mounted: function mounted() {
    this.initSwiper();
  },
  watch: {
    content: {
      handler: function handler(newVal) {
        this.list = (newVal && Array.isArray(newVal.rightTopTitle) ? newVal.rightTopTitle.filter(function (item) {
          return item !== '' && item !== null && item !== undefined;
        }) : []) || [];
        if (this.list && this.list.length > 0) {
          var calcLength = function calcLength(str) {
            return _toConsumableArray(str).reduce(function (acc, ch) {
              return acc + (/[\u4e00-\u9fa5\u3000-\u303f\uff00-\uffef]/.test(ch) ? 1 : 0.5);
            }, 0);
          };
          var maxLength = Math.max.apply(Math, _toConsumableArray(this.list.map(function (item) {
            return calcLength(item);
          })));
          this.maxWidth = parseFloat((Math.ceil(maxLength * 11 + 10) / 16).toFixed(4)); // 左右padding(5px*2)，转rem
        }
      },

      deep: true,
      immediate: true
    }
  },
  data: function data() {
    return {
      currentIndex: 0,
      list: [],
      swiperRefHeight: 0,
      maxWidth: 0
    };
  },
  methods: {
    initSwiper: function initSwiper() {},
    handleItemClick: function handleItemClick() {
      this.$emit('item-click', this.content);
    }
  }
};